import React, { useEffect, useState, useRef, memo } from "react";
import {
  LocalVideoStream,
  VideoStreamRenderer,
} from "@azure/communication-calling";
import { useLiveStreamAppContext } from '../ContextStore/Store';

function MyLocalCameraPreview({ deviceManager, call }) {
  const { toggleStates, camera } = useLiveStreamAppContext();
  const [view, setView] = useState(null);
  const cameraPreviewRef = useRef(null);

  async function myLocalPreview() {
    if (camera) {
      try {
        const cameras = await deviceManager.getCameras();
        // Mac Safari can return a list without the stored id - fall back to the first camera
        const localCamera = cameras.find((item) => item.id === `camera:${camera}`) || cameras[0];
        if (!localCamera) return null;
        const localVideoStream = new LocalVideoStream(localCamera);
        const videoStreamRenderer = new VideoStreamRenderer(localVideoStream);
        const view = await videoStreamRenderer.createView();
        setView(view);
        return view;
      } catch (error) {
        console.error("Error creating local camera preview:", error);
      }
    }
    return null;
  }

  useEffect(() => {
    // Promise, not the `view` state - the state captured in this closure is always the
    // initial null, so the previous preview was never disposed and kept the camera busy
    const viewPromise = myLocalPreview();
    return () => {
      viewPromise.then((createdView) => createdView?.dispose?.());
    };
  }, [camera]);

  useEffect(() => {
    if (view && cameraPreviewRef.current) {
      cameraPreviewRef.current.innerHTML = "";
      cameraPreviewRef.current.appendChild(view.target);
    }
  }, [view]);

  return (
    <div
      id="camera_preview"
      ref={cameraPreviewRef}
      className="small-priview"
      style={{
        display: call?.isLocalVideoStarted ? "block" : "none",
        transform: !toggleStates.mirrorMyVideo ? "rotateY(180deg)" : "",
      }}
    ></div>
  );
}

export default memo(MyLocalCameraPreview);
